export default {
  TOAST_ERROR: ["系统繁忙，请稍后再试", "如有疑问，请联系腾讯客服"],
  MQQ_JSAPI_URL: "//open.mobile.qq.com/sdk/qqapi.js?_bid=152",
  PF_SOURCE_QQ: "mds_qq_qb",
  PF_SOURCE_WECHAT: "mds_wechat_qb",

  FILE_UPLOAD_ERROR: "上传失败，请稍后重试~",
  FILE_SIZE_EXCEED: "图片大小超出，请重新选择图片~",
  DETFAULT_IMAGE: "https://midas.gtimg.cn/store_config/1696836825125GQuKI9Ga.png",
  RULE_MSG: [
    "1、上传材料的格式仅支持图片，图片大小不可大于4M"
    // "2、请根据不同业务要求上传对应的材料，具体要求请阅读示例"
  ]
}
